import { render, staticRenderFns } from "./MultiSelectQuestion.vue?vue&type=template&id=3c08442c"
import script from "./MultiSelectQuestion.vue?vue&type=script&lang=js"
export * from "./MultiSelectQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports